import DOMPurify from 'dompurify';
import SEOHead from '../components/SEOHead';
import { HOME_MARKUP } from '../data/homeMarkup';
import '../marketing.css';

const structuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'IDGate',
    applicationCategory: 'BusinessApplication',
    applicationSubCategory: 'Identity Verification Software',
    operatingSystem: 'Web',
    description:
      'IDGate is an Aadhaar Digital KYC check-in platform for every regulated business in India — hotels, clinics, banks, offices, events, co-working spaces, exam centres, PG accommodations, and more. Guests scan a QR code, verify identity through UIDAI, complete custom fields, and one merged record is delivered to your webhook or Google Sheet.',
    url: 'https://idgate.in',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'INR',
      description: 'Free pilot available',
    },
    keywords:
      'Aadhaar verification, Aadhaar eKYC, UIDAI verification, digital check-in India, hotel KYC, clinic patient verification, office visitor management, event entry verification',
    featureList: [
      'Aadhaar QR-based eKYC verification',
      'UIDAI official verification flow with consent capture',
      'Custom check-in forms per flow',
      'Webhook and Google Sheet record delivery',
      'DPDP-compliant data handling — no guest data retained',
      'Role-based operator console access',
      'Sandbox and production UIDAI environments',
      'Works across hospitality, healthcare, financial services, events, education, government, retail, co-working and more',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'IDGate',
    url: 'https://idgate.in',
    logo: 'https://idgate.in/logos/idgate-logo-light.svg',
    description:
      'IDGate provides Aadhaar eKYC-based digital check-in for regulated businesses across India — from hotels and clinics to banks, offices, events, and government service centres.',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'sales@idgate.in',
      contactType: 'sales',
      areaServed: 'IN',
      availableLanguage: ['English', 'Hindi'],
    },
    areaServed: {
      '@type': 'Country',
      name: 'India',
    },
  },
];

const Home = () => {
  return (
    <>
      <SEOHead
        absoluteTitle="IDGate | Aadhaar Verification & Digital Check-in for Every Sector"
        description="Aadhaar Digital KYC check-in for hotels, clinics, offices, banks, events and every regulated business in India. Scan QR → UIDAI verifies → one record to your system. Free pilot."
        keywords="Aadhaar verification, Aadhaar eKYC, Aadhaar KYC, UIDAI verification, Aadhaar QR verification, mAadhaar verification, DigiLocker verification, Aadhaar based identity verification, Aadhaar OTP verification, paperless KYC India, digital KYC India, IDGate, Aadhaar check-in software, hotel Aadhaar check-in, hotel KYC software India, digital hotel check-in India, Form C compliance software, clinic patient verification India, OPD patient registration Aadhaar, hospital identity verification, office visitor management India, corporate visitor verification Aadhaar, event entry verification India, conference attendee verification, Aadhaar verification financial services, branch KYC software India, NBFC KYC onboarding, co-working space visitor management, retail age verification India, Aadhaar age verification, education exam hall verification India, PG accommodation check-in, hostel resident verification, government service centre KYC, Jan Seva Kendra verification, Ayushman Bharat patient verification, gated community visitor management, DPDP compliant KYC software, identity verification platform India, regulated check-in India, QR code check-in India, digital identity verification India, contactless check-in India, Aadhaar API integration, UIDAI partner India"
        url="https://idgate.in"
        structuredData={structuredData}
      />
      <div
        className="idgate-marketing"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(HOME_MARKUP) }}
      />
    </>
  );
};

export default Home;
